// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.botaoClear {
  position: relative;
  width: 26px;
  height: 26px;
  left: 565px;
  bottom: 20px;
}

.botaoSave {
  position: fixed;
  width: 38px;
  height: 38px;
  left: 1220px;
  top: 570px;
}

.botaoEnviar {
  position: fixed;
  width: 38px;
  height: 38px;
  left: 1270px;
  top: 570px;
}

.botaoVoltar {
  position: fixed;
  width: 38px;
  height: 38px;
  left: 83px;
  top: 570px;
}

.botaoTrocar{
  margin-top: 20px;
  color: var(--cDark);
  background: var(--asAzulClaro);
  border: 1.8px solid var(--pAzul);
  border-radius: 15.5px;
  width: 300px;
  height: 40px;
}

.botaoTrocar:focus {
  background: var(--aiLaranja);
  color: var(--cBranco);
}

.botaoAnexo {
  position: fixed;
  width: 38px;
  height: 38px;
  left: 1270px;
  top: 87px;
}

@media (width > 1900px) {
  .botaoSave {
    position: absolute;
    width: 38px;
    height: 38px;
    left: 1220px;
    top: 530px;
  }
  
  .botaoEnviar {
    position: absolute;
    width: 38px;
    height: 38px;
    left: 1270px;
    top: 530px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/botao/Botao-style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":[".botaoClear {\n  position: relative;\n  width: 26px;\n  height: 26px;\n  left: 565px;\n  bottom: 20px;\n}\n\n.botaoSave {\n  position: fixed;\n  width: 38px;\n  height: 38px;\n  left: 1220px;\n  top: 570px;\n}\n\n.botaoEnviar {\n  position: fixed;\n  width: 38px;\n  height: 38px;\n  left: 1270px;\n  top: 570px;\n}\n\n.botaoVoltar {\n  position: fixed;\n  width: 38px;\n  height: 38px;\n  left: 83px;\n  top: 570px;\n}\n\n.botaoTrocar{\n  margin-top: 20px;\n  color: var(--cDark);\n  background: var(--asAzulClaro);\n  border: 1.8px solid var(--pAzul);\n  border-radius: 15.5px;\n  width: 300px;\n  height: 40px;\n}\n\n.botaoTrocar:focus {\n  background: var(--aiLaranja);\n  color: var(--cBranco);\n}\n\n.botaoAnexo {\n  position: fixed;\n  width: 38px;\n  height: 38px;\n  left: 1270px;\n  top: 87px;\n}\n\n@media (width > 1900px) {\n  .botaoSave {\n    position: absolute;\n    width: 38px;\n    height: 38px;\n    left: 1220px;\n    top: 530px;\n  }\n  \n  .botaoEnviar {\n    position: absolute;\n    width: 38px;\n    height: 38px;\n    left: 1270px;\n    top: 530px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
